/**
 * The main javascript file
 */

//- use it in template parts to fetch the locale from WP/php
let wpLocale;

//- FIRST let's import BS breakpoints in JS
let breakpoint = {};
breakpoint.refreshValue = function() {
  this.value = window
    .getComputedStyle(document.querySelector("body"), ":before")
    .getPropertyValue("content")
    .replace(/\"/g, "");
};

function debounce(callback, delay){
  var timer;
  return function(){
      var _this = this;
      clearTimeout(timer);
      timer = setTimeout(function(){
        callback.apply(_this);
      }, delay)
  }
}

// numbers formatting
function number_format(number, decimals, decPoint, thousandsSep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var s = ''

  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + (Math.round(n * k) / k)
      .toFixed(prec)
  }

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }

  return s.join(dec)
}

function isLocale(locale, country){
  return locale.toLowerCase().indexOf(country) !== -1;
}

function numberFormatI18n(number, decimals, locale) {
  if (isLocale(locale, 'en')) {
    return (number_format(number, decimals, '.', ','));
  } else if (isLocale(locale, 'es') || isLocale(locale, 'nl')) {
      return (number_format(number, decimals, ',', '.'));
  } else {
      return (number_format(number, decimals, ',', ' '));
  }
}

function currencyFormatI18n(number, decimals, locale) {
  if ((isLocale(locale, 'en')) || (isLocale(locale, 'nl'))) {
    return ("€" + numberFormatI18n(number, decimals, locale));
  } else if (isLocale(locale, 'es')) {
      return (numberFormatI18n(number, decimals, locale) + " €");
  } else {
      return (numberFormatI18n(number, decimals, locale) + " €");
  }
}

/**************************************************
 * INTERCOM
 *
 * 2 functions : one to load the library, one to launch the chat
 **************************************************/

function loadIntercom() {
  const domain = location.origin;
  const w = window;
  const ic = w.Intercom;

  w.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "",
  };
  if (domain.indexOf('next') !== -1) {
    w.intercomSettings.app_id = 'k5r89p4v';
  } else {
    w.intercomSettings.app_id = 'cil9g4x8';
  }

  if (typeof ic === 'function') {
    ic('reattach_activator'); ic('update', w.intercomSettings);
  } else {
    var d = document;
    var i = function () { i.c(arguments) };
    i.q = [];
    i.c = function (args) { i.q.push(args) };
    w.Intercom = i;
    function l() {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + w.intercomSettings.app_id;
      var x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
    if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}

function launchChat() {
  window.Intercom('show');
}

/**************************************************
 * GOOGLE TAG MANAGER
**************************************************/
function trackEvents() {
  const domain = location.origin;

  if (domain.indexOf('next') == -1 && domain.indexOf('local') == -1) {
    $('[event]').on('focus blur click', function(e) {
      var target = $(e.target);

      if (!!window.dataLayer) {
        window.dataLayer.push({
          'event': e.type,
          'element': target.attr('event')
        });
      }
    });
  }
}

/**************************************************
 * COMPLIANZ
 * Show the banner when a html element with class 'cmplz-show-banner' is clicked
 * https://complianz.io/add-a-link-to-show-the-cookie-banner/
**************************************************/
function addEvent(event, selector, callback, context) {
  document.addEventListener(event, e => {
      if ( e.target.closest(selector) ) {
          callback(e);
      }
  });
}
addEvent('click', '.cmplz-show-banner', function(){
  document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
      obj.click();
  });
});

/**************************************************
 * Functions run on every page (in the footer)
**************************************************/
function asyncFooterScripts() {
  // Loading Intercom
  loadIntercom();
  // Tracking GTM
  trackEvents();
}

//- SMOOTH SCROLLING ELEMENT TO BOTTOM
$.fn.smoothScrollBottom = function() {
  var offset = $(this).offset().top + $(this).height() - $(window).height() + 10;
  return $("html, body").animate({ scrollTop: offset }, "slow");
};
//- SMOOTH SCROLLING TO ELEMENT
$.fn.smoothScrollTop = function() {
  var offset = $(this).offset().top - 40;
  return $("html, body").animate({ scrollTop: offset }, "slow");
};

//- HASH SMOOTH SCROLLING
$('a[href*="#"]')
  .not('[href="#"]')
  .not('.stats a[href^="#"]')
  .not('a.goback[href*="#"]')
  .not('[href="#gmap"]')
  .not('.offer a[href*="#"]')
  .not('[href*="/#partners-signup"]')
  .click(function(e) {
    if (this.hash) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: $(this.hash).offset().top }, "slow");
    }
  });
//- fix a bug in 'menu image' plugin
$('.hovered-image').css('margin-left', '-48px');

/****************************************************************************************************
 * ON LOAD SCOPE
****************************************************************************************************/
$(function () {

  /**
   *
   * cookies
  */
  const source = getParameterByName('source');
  if (source) {
    Cookies.set('source', source, {expires: 1, secure: 'secure'});
  }

  const referrer = getParameterByName('referrer');
  if (referrer) {
    Cookies.set('referrer', referrer, {expires: 1, secure: 'secure'});
  }

  //- get current CSS breakpoint
  $(window).resize(function () {
    breakpoint.refreshValue();
  }).resize();

  /**************************************************
   * ACCORDION MENU
   * PRESS > ALL ABOUT US +
   * ABOUT > TEAM MEMBERS
   **************************************************/
  if ($("#documents").length || $("#team").length) {
    //init accordion menu
    $('.list').each(function () {
      $(this).hide();
    });
    let currentMenuId = $('.menu a.active').attr('id');
    $('.list.' + currentMenuId).show();

    //- accordion animation function
    function accordion(currentMenuId, targetMenuId) {
      //- fade out current cards and slide up current menu
      $('.list.' + currentMenuId + ' .card').fadeOut('fast');
      $('.list.' + currentMenuId).slideUp('fast', function () {
        //- then slide down clicked menu and fadein its cards
        $('.menu a#' + currentMenuId).removeClass('active');
        $('.list.' + targetMenuId).delay(150).slideDown('fast');
        $('.list.' + targetMenuId + ' .card').fadeIn(1000);
        $('.menu a#' + targetMenuId).removeClass('active').addClass('active');
      });
    }

    //clic on accordion menu : show/hide cards with transitions
    $('.menu a').on('click', function (event) {
      event.preventDefault();
      let targetMenuId = $(this).attr('id');
      let currentMenuId = $('.menu a.active').attr('id');
      //- on mobile: set accordion on top of the screen before playing it
      let offset = $('.menu.mobile').offset().top;
      let scrollDuration = 0;
      if (offset != 0) {
        $('html, body').animate({ scrollTop: offset }, scrollDuration, function () {
          accordion(currentMenuId, targetMenuId);
        });
        //- else juste playing accordion
      } else {
        accordion(currentMenuId, targetMenuId);
      }
    });
  }

  /**************************************************
   * SIMPLE ACCORDION MENU
   * INDUSTRIES
   * ABOUT > CAREERS
   **************************************************/
  if ($("#industry-support").length || $("#teams").length) {
    $('.simple-accordion-item .title').on('click', function(e){
      e.preventDefault();
      var plus = $(this).find('.plus-minus');
      $('.plus-minus').removeClass('active');
      plus.addClass('active').toggleClass('closed');
      $('.plus-minus:not(.active)')
        .addClass('closed')
        .parents('.simple-accordion-item').find('.text').removeClass('expanded');
      $(this).parents('.simple-accordion-item').find('.text').toggleClass('expanded');
    });
  }

  /**************************************************
   * Trustpilot widgets script
   **************************************************/
  if ($("#trustpilot").length) {
    var script = document.createElement('script'),
    scripts = document.getElementsByTagName('script')[0];
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.setAttribute('defer', 'defer');
    scripts.parentNode.insertBefore(script, scripts);
    //small display bug fixes
    $('.button').css('z-index', 'auto');
  }

});
